<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Skus'"></span>
          <v-btn
            class="mx-2 mb-2"
            fab
            x-small
            color="primary"
            to="/skus/create"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    @keydown.enter="getData"
                    @change="page = 1"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title v-if="skus.length != 0">
              <v-spacer></v-spacer>
              <v-btn class="primary mx-4" @click="generateExcel()">
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Sku Name</th>
                    <th class="text-left">Brand</th>
                    <th class="text-left">Hsn Code</th>
                    <th class="text-left">MRP</th>
                    <th class="text-left">Image</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="skus.length != 0">
                  <tr v-for="(sku, i) in skus" :key="`sku${i}`">
                    <td style="min-width: 85px">
                      {{ i + 1 }}
                    </td>
                    <td>{{ sku.name || "" }}</td>
                    <td>{{ sku.brand.description || "" }}</td>
                    <td>{{ sku.hsn_code || "" }}</td>
                    <td>{{ sku.price || "" }}</td>
                    <td>
                      <a
                        v-if="sku.image_path"
                        target="_blank"
                        :href="`${mediaUrl}${sku.image_path}`"
                      >
                        <v-img
                          class="mx-auto"
                          :src="`${mediaUrl}${sku.image_path}`"
                          width="200"
                        ></v-img>
                      </a>
                    </td>

                    <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/skus/${sku.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "skusPage",
  data() {
    return {
      form: {
        active: 1,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_skus: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log(this.form.supervisor_id);
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let skus = [];
      let query = "page=" + this.page + "&rowsPerPage=" + this.rowsPerPage;
      skus = await axios.get(`skus?${query}`);
      this.skus = skus.data.data;
      // this.skus = skus.data.data.filter(user => {
      //   return user.roles[0].name === 'USER';
      // });
      // console.log(this.skus);
      this.count = skus.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    //  async Delete_this(id) {
    //   let check = confirm("Are you sure you want to delete the data");
    //   if (check) {
    //     try {
    //       this.isLoading = true;
    //       await axios.delete(`skus/${id}`);
    //       this.isLoading = false;
    //       this.getData();
    //     } catch (e) {
    //       this.isLoading = false;
    //     }
    //   }
    // },

    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_skus = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id;
      Export_skus = await axios.get(`skus?${query}`);
      this.Export_skus = Export_skus.data.data;

      this.Export_skus.forEach((sku) => {
        this.ExportUsers.push({
          sr_no: sku.sr_no,
          name: sku.name ? sku.name.toUpperCase() : "",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id +
        "&supervisorId=" +
        this.form.supervisor_id +
        "&designationId=" +
        this.form.designation_id;
      try {
        let response = await axios.get(`skusExports?${query}`);
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.getData();
      this.isExcelloading = false;
      console.log("a");
    },
  },
};
</script>
